import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { IWidgetComponent } from "./IWidgetComponent";
import { WidgetText } from "../Widgets/WidgetText";
import { LanguageString } from "../../../Model/LanguageString";
import { app } from "../../../Frame/App";
import { html } from "d3";

export type WidgetTextComponentProps = {
    widget: WidgetText;
    title: LanguageString;
    content: string;
}

export class WidgetTextComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetTextComponentProps;

    constructor(props: WidgetTextComponentProps) {
        super(props);
    }

    public element: HTMLElement =
        <div className="widget Background-Blur-90-MSO">
            <div className="title-row">
                <div className="title mr-auto">{(this.props.title[`value${app.languageUpperCase}`] && this.props.title[`value${app.languageUpperCase}`].trim().length > 0) ? this.props.title[`value${app.languageUpperCase}`] : this.props.title[`value${app.defaultLanguageUpperCase}`]}</div>
            </div>
            <div className="content-row">
                <div className="widget-text-content">
                    {this.props.widget.parseContentToHtml(this.props.content)}
                </div>
            </div>
        </div>;

    public render(): HTMLElement {
        this.props.widget.setGridPosition();
        return this.element;
    }
}